import React from "react";
import { Container } from 'react-bootstrap';
import { FormattedMessage } from "react-intl";

import { SnapshotRow, FleetTable, HistoricalUsage } from "pages/dashboard/main";

export const Dashboard = props => (
    <Container className="d-flex flex-column gap-3">
        <h1>
            <FormattedMessage
                id="label.dashboard"
                defaultMessage="Dashboard"
            />
        </h1>

        <SnapshotRow/>

        <hr/>

        <FleetTable/>

        <hr/>

        <HistoricalUsage/>

    </Container>
);